import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

const ModuleVersionTableEmptyCell = <T extends { id: string }>(
  cellProps: TableSimpleCellProps<T>
) => {
  return <TableSimpleCell {...cellProps} />;
};

export default ModuleVersionTableEmptyCell;
